



























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Icons
---------------------------------------- */

import ArrowDownIcon from "@icon/ArrowDownIcon";

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    components: {
        ArrowDownIcon
    },

    props: {
        project: Object
    },

    computed: {
        disciplines() {
            return this.project.disciplines.join(', ')
        },
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Next extends Vue {}

